module.exports = __webpack_public_path__ + "teqbahn-assets/media/Charlie.2215e55c.jpg";